import { render, staticRenderFns } from "./listaContatti.vue?vue&type=template&id=71989f5e"
import script from "./listaContatti.vue?vue&type=script&lang=js"
export * from "./listaContatti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports